import React from 'react';
import { graphql } from 'gatsby';

import SectionItemContentBackgroundContainer from '../SectionItems/SectionItemContentBackground';
import SectionItemContentHeadlineContainer from '../SectionItems/SectionItemContentHeadline';
import SectionItemShowroomAddressContainer from '../SectionItems/SectionItemShowroomAddress';
import SectionShowroomIntro from '../../../components/Section/SectionShowroomIntro';
import { getBackgroundImage, normalizeContentPositionX, normalizeContentPositionY } from '../utils';

// Types
import { SectionShowroomIntroContainerFragment } from './__generated__/SectionShowroomIntroContainerFragment';
import { SectionWidth } from '../../../../types/sections';

export const fragment = graphql`
  fragment SectionShowroomIntroContainerFragment on CMS_Section {
    ...SectionItemContentBackgroundContainerFragment
    ...SectionItemContentHeadlineContainerFragment
    ...SectionItemShowroomAddressContainerFragment
    backgroundColor
    backgroundPattern
    contentPositionX
    contentPositionY
    backgroundImage {
      ...SectionBackgroundImageFragment
    }
  }
`;

type Props = {
  index: number;
  isClipped: boolean;
  isCritical: boolean;
  isHiddenOnMobile: boolean;
  isNeighborClipped: boolean;
  section: SectionShowroomIntroContainerFragment;
  sectionWidth: SectionWidth;
};

const SectionShowroomIntroContainer = ({
  index,
  isClipped,
  isCritical,
  isHiddenOnMobile,
  isNeighborClipped,
  section,
  sectionWidth,
}: Props) => {
  const backgroundImage = getBackgroundImage(section);

  const contentPositionX = normalizeContentPositionX(section.contentPositionX);
  const contentPositionY = normalizeContentPositionY(section.contentPositionY);

  const contentBackground = <SectionItemContentBackgroundContainer section={section} sectionWidth={sectionWidth} />;

  const headline = (
    <SectionItemContentHeadlineContainer contentPositionY={contentPositionY} hasBackgroundImage={!!backgroundImage} section={section} />
  );

  const address = (
    <SectionItemShowroomAddressContainer
      contentPositionY={contentPositionY}
      hasBackgroundImage={!!backgroundImage}
      section={section}
      shouldNotIncludeHours={false}
    />
  );

  return (
    <SectionShowroomIntro
      address={address}
      backgroundColor={section.backgroundColor}
      backgroundImage={backgroundImage}
      backgroundPattern={section.backgroundPattern}
      contentBackground={contentBackground}
      contentPositionX={contentPositionX}
      contentPositionY={contentPositionY}
      headline={headline}
      index={index}
      isClipped={isClipped}
      isCritical={isCritical}
      isHiddenOnMobile={isHiddenOnMobile}
      isNeighborClipped={isNeighborClipped}
      sectionWidth={sectionWidth}
    />
  );
};

export default SectionShowroomIntroContainer;
